import { RootState } from '../types'
export const guidedTourRunSelector = (state: RootState): boolean => state.guidedTour.isGuidedTourRun
export const showLoadingDialogSelector = (state: RootState): boolean => state.guidedTour.isShowLoadingDialog
